module.exports = __webpack_public_path__ + "img/img-16.9517d662.png";